import styled from "@emotion/styled";
import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import React from "react";

interface FormattedTooltipProps {
  label: string;
  maxWidth?: number;
}

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))<{ maxWidth?: number }>(({ maxWidth = 400 }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: maxWidth,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontSize: "12px",
    lineHeight: "1.4",
    padding: "8px 12px",
    backgroundColor: "#333",
    color: "#fff",
    borderRadius: "4px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#333",
  },
}));

const FormattedTooltip = ({
  label,
  maxWidth = 400,
}: FormattedTooltipProps) => {
  // Function to format the text for better display
  const formatText = (text: string) => {
    if (!text) return "-";

    // Handle line breaks and preserve formatting
    return text
      .replace(/\n/g, "\n") // Preserve line breaks
      .replace(/^(\d+\.)/gm, "$1 ") // Ensure proper spacing after numbered lists
      .trim();
  };

  return (
    <CustomWidthTooltip
      title={formatText(label)}
      arrow
      placement="bottom-start"
      maxWidth={maxWidth}
    >
      <p className="text-neutral-90 font-normal common-text-ellipse-style">
        {label || "-"}
      </p>
    </CustomWidthTooltip>
  );
};

export default FormattedTooltip;
